import { useEffect, useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider, useMediaQuery } from '@mui/material'
import { usePersistedStorage } from '~/hooks'
import { useRouteContext } from '~/routes'
import ColorModeContext from './ColorModeContext'
import createTheme from './themes'

const ThemeProvider = (props) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  const [mode, setMode] = usePersistedStorage(
    'theme',
    prefersDarkMode ? 'dark' : 'light'
  )

  const colorMode = useMemo(
    () => ({
      toggle: () => {
        setMode((prevMode) => {
          return prevMode === 'light' ? 'dark' : 'light'
        })
      },
    }),
    [setMode]
  )

  const { brand } = useRouteContext(ThemeProvider.name)

  const theme = useMemo(() => createTheme(mode, brand?.url), [brand?.url, mode])

  useEffect(() => {
    if (mode === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [mode])

  return (
    <ColorModeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={theme} {...props} />
    </ColorModeContext.Provider>
  )
}

export default ThemeProvider
